// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  CanonicalAddress,
  InvitedBrandDraftRow,
} from "./types";

export const params = {
  idempotencyKey: __t.string(),
  email: __t.string(),
  expiresInDays: __t.i32(),
  businessGooglePlaceId: __t.string(),
  businessGooglePlacePhotoName: __t.option(__t.string()),
  businessName: __t.string(),
  get businessAddress() {
    return CanonicalAddress;
  },
  businessCategory: __t.string(),
  businessType: __t.string(),
  websiteUrl: __t.option(__t.string()),
  businessTags: __t.array(__t.string()),
  get targetPropertyAddress() {
    return CanonicalAddress;
  },
  targetPropertyLatitude: __t.option(__t.f64()),
  targetPropertyLongitude: __t.option(__t.f64()),
  initialPriceEstimate: __t.option(__t.f64()),
};
export const returnType = InvitedBrandDraftRow